/* eslint-disable import/prefer-default-export */
// @flow

import styled from 'styled-components';

import { GREY_50 } from 'styles/colors';
import { LINE_HEIGHT_COPY } from 'styles/line-height';
import { FONT_WEIGHT_100 } from 'styles/font-weight';
import { TYPE_SCALE_F6 } from 'styles/type-scale';
import { SPACING_SMALL, SPACING_MEDIUM, SPACING_LARGE } from 'styles/spacing';

export const RecieptEmailCopy = styled.p`
  ${TYPE_SCALE_F6};
  ${LINE_HEIGHT_COPY};
  ${FONT_WEIGHT_100};
  color: ${GREY_50};
  margin: ${SPACING_MEDIUM} auto 0;
  text-align: center;
  width: 280px; /* card width */

  &:after {
    content: '';
    display: block;
    margin: calc(${SPACING_LARGE} + ${SPACING_SMALL}) auto;
    width: 25%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/payer/success/styles.js